(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["horeca-language-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    document.querySelectorAll('.horeca-language-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('.horeca-language-menu[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); event.preventDefault(); }
  });
  document.addEventListener('submit', (event) => {
    if (event.submitter?.name !== 'language_code') return;
    const menu = event.submitter.closest('.horeca-language-menu');
    if (menu) { menu.setAttribute('aria-busy', 'true'); event.submitter.setAttribute('aria-busy', 'true'); }
  });
  } catch(e) { console.error(e); }
})();

})();
